export default "__VITE_ASSET__BCl1Lc5d__"